import * as React from "react"
import Layout from "../../components/Layout"
import Seo from "../../components/seo"
import news from "../../../content/news.json"
import { Link } from "gatsby"
import CasinoCard from "../../components/CasinoCard"
import { StaticImage } from "gatsby-plugin-image"
import AuthorCard from "../../components/AuthorCard"

const IndexPage = () => {
    const info = news.find(element => {
        return element.url === "luckycasino-firar-5-ar-med-en-tillbakablick-pa-sina-storsta-vinster";
    });

    const schemaBreadcrumb =
    {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "Hem",
            "item": "https://alcasino.se/"
        }, {
            "@type": "ListItem",
            "position": 2,
            "name": "Nyheter",
            "item": "https://alcasino.se/nyheter/"
        }, {
            "@type": "ListItem",
            "position": 3,
            "name": "LuckyCasino firar 5 år med en tillbakablick på sina största vinster",
            "item": "https://alcasino.se/nyheter/luckycasino-firar-5-ar-med-en-tillbakablick-pa-sina-storsta-vinster/"
        }]
    }

    return (
        <Layout>
            <Seo
                title={info.name + " | Casino Nyheter"}
                description={info.intro}
                schemaBreadcrumb={schemaBreadcrumb} />

            <div className="breadcrumbs">
                <div className="breadcrumbs-wrapper">
                    <span className="clickable"><Link to="/">Hem</Link></span> <span className="separator">•</span> <span className="clickable"><Link to="/nyheter/">Nyheter</Link></span> <span className="separator">•</span> <span className="last">{info.name}</span>
                </div>
            </div>

            <div className="page-header light">
                <div className="content">
                    <h1>{info.name}</h1>
                    <p>{info.date}</p>
                </div>
            </div>

            <div className="page-content">
                <StaticImage src="../../images/nyheter/luckycasino-firar-5-ar.jpg" alt="LuckyCasino firar 5 år" placeholder="none" objectFit="fill" quality={100} />
                <p>För fem år sedan, lyste en ny stjärna upp på den svenska casinohimlen - <Link to="/recensioner/luckycasino/">LuckyCasino</Link>. Sedan dess har de betalat ut över 32 miljarder kr i vinster till lyckliga spelare över hela Sverige och skrivit historia med den största jackpottvinsten någonsin.</p>

                <h2>En resa fylld med lycko ögonblick</h2>
                <p>LuckyCasino har haft många minnesvärda ögonblick under sina fem år. Här är några av de största vinsterna:</p>
                <ul className="marker">
                    <li>146 miljoner kr på Mega Moolah (2020): Denna otroliga vinst är den största jackpottvinsten någonsin på ett svenskt nätcasino och var den fjärde största i världshistorien vid den tiden. Läs mer om <Link to="/spelautomater/mega-moolah/">Mega Moolah</Link> här.</li>
                    <li>3,1 miljoner kr på Divine Fortune (2023): En lycklig spelare från Huddinge vann denna enorma summa med en insats på bara 8 kr. Läs mer om Divine Fortune här.</li>
                    <li>1,7 miljoner kr på Divine Fortune (2022): En 57-årig lyckost från Dalarna förvandlade en insats på 40 kr till 1,7 miljoner kr.</li>
                    <li>1,6 miljoner kr på Sisters of Oz: WowPot (2023): En spelare från Helsingborg vann denna imponerande summa med en insats på bara 8 kr.</li>
                    <li>1,2 miljoner kr på Divine Fortune (2022): En lycklig vinnare från Norrtälje kammade hem över 20 000 gånger sin insats.</li>
                </ul>

                <h2>Tack till alla spelare</h2>
                <p>LuckyCasino vill tacka alla sina spelare. Utan er hade ingenting varit möjligt. Så här säger de:</p>
                <p>"Innan vi hugger in i födelsedagstårtan vill vi tacka dig som valt att dela spänningen, glädjen och de stora lyckoögonblicken med oss under resans gång. Utan just dig vid vår sida hade ingenting varit möjligt."</p>

                <h2>Framtiden ser ljus ut</h2>
                <p>Med fem framgångsrika år bakom sig ser framtiden ljus ut för LuckyCasino. Vi ser fram emot att se vilka nya lycko-ögonblick som väntar runt hörnet. Kommer du att vara nästa stora vinnare?</p>
                <CasinoCard ids={["luckycasino"]} />

                <h2>Dubbelt upp eller pengarna tillbaka på LuckyCasino</h2>
                <p>I skrivande stund erbjuder LuckyCasino alla nya spelare på sajten ett annorlunda välkomsterbjudande som de kallar, Dubbelt upp - eller pengarna tillbaka.</p>
                <p>Det går ut på att om du inte lyckas dubbla din första insättning under de första 24 timmarna får du tillbaka 100 kr att spela för. Exempelvis om du sätter in 100 kr, och inte lyckas fördubbla det, då får du tillbaka pengarna 24 timmar efter första insättningen.</p>
                <p>Ett mycket simpelt erbjudande, som likt andra har ett antal regler att förhålla sig till.</p>
                <ul className="marker">
                    <li>Maxbelopp att få tillbaka 100 kr.</li>
                    <li>Gäller under de första 24 timmarna.</li>
                    <li>Maxinsatsen för casino är 50 kr.</li>
                    <li>60 dagar på dig att ta del av pengarna som betalas tillbaka.</li>
                </ul>
                <AuthorCard author={info.author} />
            </div>
        </Layout>
    )
}

export default IndexPage